// Mirrors backend/middleware/auth.js role semantics: super_admin is a strict
// superset of admin (everything an admin can do, plus user management, the
// activity log, stats, and AI administration).
export const isSuperAdmin = (role) => role === 'super_admin';
export const isAdminLike = (role) => role === 'admin' || role === 'super_admin';
export const isStaff = (role) => isAdminLike(role) || role === 'pricer';
